import { ICancelarAprovacaoColetaPrecoFornecedorUseCase } from "../../../presentation/useCases/update/cancelar_aprovacao_coleta_preco_fornecedor_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * CancelarAprovacaoColetaPrecoFornecedorUseCase
 */

export class CancelarAprovacaoColetaPrecoFornecedorUseCase implements ICancelarAprovacaoColetaPrecoFornecedorUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async cancelarAprovacaoColetaPrecoFornecedor(
    idColetaPreco: number,
  ): Promise<void> {
    await this.repository.cancelarAprovacaoColetaPrecoFornecedor(
      idColetaPreco,
    );
  }
}
